import * as yup from 'yup';

import { getDay100YearsBefore } from '@/utils/dates/dates';
import { isEvbVisible } from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';

const vorhandeneEVBSchema = yup.object({
  evbVersicherungsbeginnAmTagDerZulassung: yup.boolean().default(true),
  evbVersicherungsbeginn: yup
    .date()
    .nullable()
    .default(null)
    .min(getDay100YearsBefore())
    .test({
      message: 'Bitte füllen Sie das Pflichtfeld aus.',
      name: 'isRequired',
      test(value, ctx) {
        const eVBState = (
          ctx.options.context as Record<string, Record<string, unknown>>
        ).evb;
        const willBeProvidedLater = eVBState.willBeProvidedLater as boolean;

        const parent = ctx.parent as VorhandeneEVB;
        const isRequired =
          isEvbVisible.value &&
          !willBeProvidedLater &&
          !parent.evbVersicherungsbeginnAmTagDerZulassung;

        if (!isRequired) {
          return true;
        }

        return value !== null && value !== undefined;
      },
    }),
  vorhandeneEvbNummer: yup
    .string()
    .default('')
    .test({
      message: 'Bitte füllen Sie das Pflichtfeld aus.',
      name: 'isRequired',
      test(value, ctx) {
        const eVBState = (
          ctx.options.context as Record<string, Record<string, unknown>>
        ).evb;
        const willBeProvidedLater = eVBState.willBeProvidedLater as boolean;
        const isRequired = isEvbVisible.value && !willBeProvidedLater;

        if (!isRequired) {
          return true;
        }

        return value !== null && value !== undefined && value !== '';
      },
    })
    .test({
      name: 'length',
      message: 'Bitte geben Sie die 7 stellige eVB-Nummer ein.',
      test(value, ctx) {
        const eVBState = (
          ctx.options.context as Record<string, Record<string, unknown>>
        ).evb;
        const willBeProvidedLater = eVBState.willBeProvidedLater as boolean;
        const isRequired = isEvbVisible.value && !willBeProvidedLater;

        if (!isRequired) {
          return true;
        }

        return value.length === 7;
      },
    }),
});

type VorhandeneEVB = yup.Asserts<typeof vorhandeneEVBSchema>;

export const eVBContractSchema = yup.object({
  willBeProvidedLater: yup.boolean().default(false),
  vorhandeneEvb: vorhandeneEVBSchema,
});
